import { Box } from '@mui/system'
import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { handleCancelOpen } from '../../../../../../helpers'
import { useDefaultComponentTools } from '../../../../../../hooks/useDefaultComponentTools'
import { selectAccessToken } from '../../../../../../store/redusers/auth/selectors'
import { setCancelOpenAction} from '../../../../../../store/redusers/orders/actions'
import { selectPositionPnl } from '../../../../../../store/redusers/positions/selectors'
import { selectUserId } from '../../../../../../store/redusers/user/selectors'
import AppButton from '../../../../../AppButton'
import AppPopup from '../../../../../AppPopup'

const TableCellPnl = ({cell, positionId}) => {
	const {dispatch, alert, theme, t } = useDefaultComponentTools(true)
	const accessToken = useSelector(selectAccessToken)
	const isAuthorized = useSelector(selectUserId)
	const positionPnl = useSelector(selectPositionPnl(positionId))
	const [isShowPopup, setIsShowPopup] = useState(false)
	const colors = positionPnl >= 0 ? theme.palette.green : theme.palette.red
	const currentAction = () => handleCancelOpen(dispatch,
		setCancelOpenAction(positionId, accessToken, isAuthorized), alert, t)

	return (
		<Box
			align='right'
			sx={{
				m: '0 4px',
				minWidth: `calc(${cell.width} - 8px)`
			}}
		>
			<Box sx={{display: 'flex', justifyContent: 'center'}}>
				<AppButton
					inputSx={{'&:hover': {
						background: colors,
						color: '#FFFFFF'
					}, background: theme.palette.second ,
					color: colors,
					height: '32px',
					textTransform: 'capitalize', width: '100%'
					}}
					variant={''}
					disabled={false}
					onClick={() => setIsShowPopup(true)}
					title={positionPnl}
					type={''}
					uppercase={false}
				/>
			</Box>
			{!isShowPopup ?
				null :
				<AppPopup
					onAction={currentAction}
					setOpenedComponent={setIsShowPopup}
					title={'Close Trade'}
					text={'Are you sure. You want to close trade?'}
					actionTitle={'Close'}
				/>
			}
		</Box>
	)
}

TableCellPnl.propTypes = {
	cell: PropTypes.object,
	positionId: PropTypes.string
}

export default TableCellPnl
